import { createFeatureSelector, createSelector } from '@ngrx/store';

import { USER_CONFIGURATION_MODULE_KEY } from '../../+state/user-configuration.declarations';
import { UserConfigurationPartialState } from '..';

/** state */
const getModuleState = createFeatureSelector<UserConfigurationPartialState>(
  USER_CONFIGURATION_MODULE_KEY
);
const getCalendarConfigurationState = createSelector(
  getModuleState,
  state => state.calendarConfiguration
);

/** forms */
const getCalendarConfigurationForm = createSelector(
  getCalendarConfigurationState,
  state => state.calendarConfigurationForm
);

const getOriginalCalendarConfiguration = createSelector(
  getCalendarConfigurationState,
  state => state.originalCalendarConfiguration
);

const getIsFormUnchanged = createSelector(
  getCalendarConfigurationForm,
  getOriginalCalendarConfiguration,
  (formState, originalConfig) => {
    const currentValues = formState.value;

    // Only compare autoRefreshTimeInMinutes if both current and original have isAutoRefresh enabled
    const shouldCompareRefreshTime = currentValues.isAutoRefresh && originalConfig.isAutoRefresh;
    const isRefreshTimeUnchanged = !shouldCompareRefreshTime ||
      currentValues.autoRefreshTimeInMinutes === originalConfig.autoRefreshTimeInMinutes;

    return (
      currentValues.calendarViewTypeId === originalConfig.calendarViewTypeId &&
      currentValues.isAutoRefresh === originalConfig.isAutoRefresh &&
      isRefreshTimeUnchanged &&
      currentValues.monthlyRibbonTypeId === originalConfig.monthlyRibbonTypeId &&
      currentValues.monthlyShowPilotInitials === originalConfig.monthlyShowPilotInitials &&
      currentValues.monthlyShowPaxCount === originalConfig.monthlyShowPaxCount &&
      currentValues.monthlyShowAircraftLastKnownLocation === originalConfig.monthlyShowAircraftLastKnownLocation &&
      currentValues.weekShowTails === originalConfig.weekShowTails &&
      currentValues.weekShowStaff === originalConfig.weekShowStaff &&
      currentValues.staffViewTypeId === originalConfig.staffViewTypeId &&
      currentValues.staffShowTails === originalConfig.staffShowTails &&
      currentValues.staffShowStaff === originalConfig.staffShowStaff &&
      currentValues.staffShowMetrics === originalConfig.staffShowMetrics &&
      currentValues.buildTripViewTypeId === originalConfig.buildTripViewTypeId
    );
  }
);

/** exports */
export const calendarConfigurationQuery = {
  // state
  getCalendarConfigurationState,
  // forms
  getCalendarConfigurationForm,
  getIsFormUnchanged
};
